import { CategoryKeys } from '@/root/utils/common/functions/get-category-from-path'

export const hideComplianceInfoCategories = [
  // articles
  CategoryKeys.ARTICLES_HOME,
  CategoryKeys.ARTICLES_DETAIL,
  CategoryKeys.ARTICLES_CATEGORY_DETAIL,

  // indices
  CategoryKeys.INDICES_HOME,
  CategoryKeys.INDICES_DETAIL,

  // calculators
  CategoryKeys.CALCULATORS_HOME,
  CategoryKeys.CALCULATORS_PAGE,

  CategoryKeys.CALCULATORS_BROKERAGE,
  CategoryKeys.CALCULATORS_HRA,
  CategoryKeys.CALCULATORS_NPS,
  CategoryKeys.CALCULATORS_SALARY,
  CategoryKeys.CALCULATORS_TERM_INSURANCE,
  CategoryKeys.CALCULATORS_INCOME_TAX,
  CategoryKeys.CALCULATORS_DIRECT_REGULAR_MF,
]
